import { RouteDtoModelType } from '../../store/mst/models';
import { TimelineViolationTypes } from '../../helpers/lateness';

export function getDispatchTagViolationProperties(routes: RouteDtoModelType[]) {
  const typeOfTagViolationsSet = new Set<string>();
  let routesWithTagViolations = 0;
  let ordersWithTagViolations = 0;
  let countOfOrdersDispatched = 0;

  routes.forEach((route) => {
    const hasRouteTags = (route.tags?.length ?? 0) > 0;
    let routeHasViolation = false;

    route.timeline?.forEach((event) => {
      if (!event.isStopEvent) return;

      const orderCount = event.orders?.length ?? 0;
      countOfOrdersDispatched += orderCount;

      const hasTagMismatch = event.violations?.some(
        (v) => v.type === TimelineViolationTypes.TAG_MISMATCH,
      );

      if (hasTagMismatch) {
        ordersWithTagViolations += orderCount;
        routeHasViolation = true;
      }
    });

    if (routeHasViolation) {
      routesWithTagViolations += 1;
      typeOfTagViolationsSet.add(hasRouteTags ? 'mismatched tags' : 'route with no tag');
    }
  });

  return {
    countOfRoutesDispatched: routes.length,
    countOfOrdersDispatched,
    routesWithTagViolations,
    ordersWithTagViolations,
    typeOfTagViolations: [...typeOfTagViolationsSet],
  };
}
